import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import OnboardLoginScreen from './onboard/onboard-login';
import OnboardRegisterScreen from './onboard/onboard-register';
import OnboardVerificationCodeScreen from './onboard/onboard-code';
import OnboardLoginResetPasswordScreen from './onboard/onboard-login-reset-password';
import OnboardPlanScreen from './onboard/onboard-plan';
import OnboardResubscribeScreen from './onboard/onboard-resubscribe';
import OnboardOfferLVS from './onboard/onboard-offer-lvs';
import Checkout from '../checkout/checkout';
import ManageSubscription from '../authenticated/settings/manage-subscription';
import { SnackbarProvider } from '../authenticated/SnackbarProvider';
import LogoutRoute from '../logout-route';

const UnauthenticatedApp = () => (
    <SnackbarProvider>
        <main id="main-content" style={{ zoom: document.documentElement.style.zoom || 1 }}>
            <Routes>
                <Route path="/" element={<OnboardLoginScreen />} />
                <Route path="/onboard/login" element={<OnboardLoginScreen />} />
                <Route path="/onboard/login/reset-password" element={<OnboardLoginResetPasswordScreen />} />
                <Route path="/onboard/register" element={<OnboardRegisterScreen />} />
                <Route path="/onboard/code" element={<OnboardVerificationCodeScreen />} />
                <Route path="/onboard/plan" element={<OnboardPlanScreen />} />
                <Route path="/onboard/resubscribe" element={<OnboardResubscribeScreen />} />
                <Route path="/onboard/offer-lvs" element={<OnboardOfferLVS />} />
                <Route path="/lvs" element={<OnboardOfferLVS />} />
                <Route path="/onboard/offer-expo" element={<OnboardOfferLVS />} />
                <Route path="/expo" element={<OnboardOfferLVS />} />
                <Route path="/checkout" element={<Checkout isOnboarding={true} />} />
                <Route path="/settings/manage-subscription" element={<ManageSubscription />} />
                <Route path="/logout" element={<LogoutRoute />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </main>
    </SnackbarProvider>
);

export default UnauthenticatedApp;
